module.exports = __webpack_public_path__ + "img/img2.aaf9bdba.png";